var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column min-vh-100 content__background",
    class: {
      'is-flex': _vm.getModuleConfig('card_layout') === 'flex'
    },
    style: _vm.getModuleConfig('layout.display_bg_image') && {
      'background-image': "url(".concat(_vm.getModuleConfig('layout.bg_image'), ")")
    }
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('div', {
    staticClass: "top",
    style: _vm.topStyle
  }, [_c('div', {
    class: "layout layout-".concat(_vm.getModuleConfig('member_card_section.background_layout')),
    style: {
      backgroundColor: _vm.gradientColors[3]
    }
  }, [_c('svg', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "wave",
      "clipPathUnits": "objectBoundingBox"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1,0V1c-0.0467-0.0352-0.1107-0.0848-0.2133-0.1004c-0.1026-0.0148-0.2267,0.0464-0.3481,0.0684C0.3067,0.9916,0.1333,1.008,0,0.892V0H1Z"
    }
  })])])]), _c('svg', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "wave-barcode",
      "clipPathUnits": "objectBoundingBox"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 0v1C.953.974.89.938.786.927.684.916.56.96.438.977.307.994.133 1.006 0 .92V0z"
    }
  })])])]), _c('svg', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "wave-qrcode",
      "clipPathUnits": "objectBoundingBox"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 0v1C.953.983.89.959.787.951.684.944.56.974.438.985.307.995.133 1.004 0 .948V0z"
    }
  })])])]), _vm._l(3, function (i) {
    return _c('div', {
      key: i,
      class: "curve-".concat(4 - i),
      style: {
        backgroundColor: _vm.gradientColors[3 - i]
      }
    });
  }), _c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section')
    }
  }), _c('div', {
    staticClass: "py-3 px-2"
  }, [_vm.getModuleConfig('member_card_section.enable') == true ? _c('div', {
    staticClass: "card",
    class: "layout-".concat(_vm.getModuleConfig('member_card_section.card_layout')),
    style: _vm.cardBackground
  }, [_c('div', {
    staticClass: "card__logo"
  }, [_vm.getModuleConfig('member_card_section.display_logo') ? _c('img', {
    style: {
      width: _vm.getModuleConfig('member_card_section.logo_style.width'),
      transform: "translate(".concat(_vm.getModuleConfig('member_card_section.logo_style.translateX') || '0', ",").concat(_vm.getModuleConfig('member_card_section.logo_style.translateY') || '0', ")")
    },
    attrs: {
      "src": _vm.memberCardLevelLogo
    }
  }) : _vm._e()]), _vm.getModuleConfig('member_card_section.display_name') == true ? _c('div', {
    staticClass: "card__name"
  }, [_vm._v(" " + _vm._s(_vm.displayMemberName) + " ")]) : _vm._e(), _c('div', {
    staticClass: "card__avatar"
  }, [_vm.getModuleConfig('member_card_section.display_customer_avatar') == true ? _c('img', {
    staticClass: "rounded-circle",
    attrs: {
      "src": _vm.modifiedUser.avatar_url
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "card__level",
    style: {
      color: "".concat(_vm.getModuleConfig('member_card_section.customer_level_name_color')),
      'border-color': "".concat(_vm.getModuleConfig('member_card_section.customer_level_name_color')),
      visibility: "".concat(_vm.getModuleConfig('member_card_section.display_customer_level_name') && _vm.modifiedUser.loyalty.level_name ? 'visible' : 'hidden')
    }
  }, [_vm.getModuleConfig('member_card_section.display_customer_level_name') == true && _vm.modifiedUser.loyalty.level_name ? [_vm._v(" " + _vm._s(_vm.modifiedUser.loyalty.level_name) + " ")] : _vm._e()], 2), _c('div', {
    staticClass: "card__point"
  }, [_vm.getModuleConfig('member_card_section.display_points') == true ? _c('div', {
    staticClass: "card__point__title",
    style: {
      color: "".concat(_vm.getModuleConfig('member_card_section.customer_points_name_color'))
    }
  }, [_vm._v(" " + _vm._s(_vm.displayPointsName) + " ")]) : _vm._e(), _vm.getModuleConfig('member_card_section.display_points') == true ? _c('div', {
    staticClass: "card__point__number",
    style: {
      color: "".concat(_vm.getModuleConfig('member_card_section.customer_points_color'))
    }
  }, [_vm._v(" " + _vm._s(_vm.userPoints) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "card__minibarcode",
    style: {
      visibility: "".concat(_vm.getModuleConfig('member_card_section.display_mini_barcode') == true ? 'visible' : 'hidden')
    }
  }, [_vm.getModuleConfig('member_card_section.display_mini_barcode') == true ? [_c('button', {
    on: {
      "click": function click($event) {
        return _vm.$refs.minibarcode.open();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/mini-barcode.svg")
    }
  })]), _c('div', {
    staticClass: "barcode-modal"
  }, [_c('popup', {
    ref: "minibarcode",
    attrs: {
      "noActions": true,
      "scrolling": true
    }
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card__minibarcode__title"
  }, [_vm._v(_vm._s(_vm.getModuleConfig('member_card_section.barcode_title')))]), _vm.showBarcodeError ? _c('p', {
    staticClass: "s-text-danger"
  }) : _c('img', {
    attrs: {
      "id": "card__barcode-img",
      "src": _vm.barcode
    }
  })])])], 1)] : _vm._e()], 2)]) : _vm._e(), _vm.getModuleConfig('member_card_section.display_barcode') == true ? _c('div', {
    staticClass: "card__barcode mt-3"
  }, [_c('div', {
    staticClass: "card__barcode__title"
  }, [_vm._v(_vm._s(_vm.getModuleConfig('member_card_section.barcode_title')))]), _vm.showBarcodeError ? _c('p', {
    staticClass: "s-text-danger"
  }) : _c('img', {
    attrs: {
      "id": "card__barcode-img",
      "src": _vm.barcode
    }
  })]) : _vm._e(), _vm.getModuleConfig('member_card_section.display_qrcode') == true ? _c('div', {
    staticClass: "card__qrcode mt-3"
  }, [_vm.showQrcodeError ? _c('p', {
    staticClass: "s-text-danger"
  }, [_vm._v(" 無法生成 QR code ")]) : _c('div', {
    staticClass: "card__qrcode__container"
  }, [_c('div', {
    staticClass: "card__qrcode__title"
  }, [_vm._v(_vm._s(_vm.getModuleConfig('member_card_section.qrcode_title')))]), _c('button', {
    on: {
      "click": function click($event) {
        return _vm.$refs.qrcode.open();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.qrcode,
      "alt": "QR Code"
    }
  })])]), _c('div', {
    staticClass: "barcode-modal"
  }, [_c('popup', {
    ref: "qrcode",
    attrs: {
      "noActions": true,
      "scrolling": true
    }
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_vm.showQrcodeError ? _c('p', {
    staticClass: "s-text-danger"
  }) : _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.qrcode
    }
  })])])], 1)]) : _vm._e()])], 2)]), _c('div', {
    staticClass: "flex-fill body pt-2",
    style: _vm.bodyStyle
  }, [_vm.isSectionLoading ? _c('div', {
    staticClass: "text-center my-2"
  }, [_c('b-spinner', {
    staticClass: "pl-6",
    attrs: {
      "variant": "secondary"
    }
  })], 1) : [_vm._l(_vm.sections, function (section, index) {
    return _c('div', {
      key: 'section' + index,
      staticClass: "mb-3"
    }, [section.key === 'menu_icon_section' ? _c('div', {
      staticClass: "px-2"
    }, [_c('div', {
      staticClass: "function"
    }, _vm._l(section.menu_items.filter(function (x) {
      return !x.is_hidden;
    }), function (i, idx) {
      return _c('div', {
        key: idx,
        staticClass: "function__item",
        style: {
          'flex-basis': "".concat(100 / section.column_number, "%")
        }
      }, [i.is_external ? [_c('a', {
        attrs: {
          "target": i.target ? i.target : '_blank',
          "href": i.url
        }
      }, [i.icon_url == undefined || i.icon_url.split('.').pop() == 'svg' ? _c('div', {
        staticClass: "function__icon__wrapper"
      }, [_c('img', {
        staticClass: "function__icon",
        style: {
          maskImage: _vm.getIconMask(i),
          webkitMaskImage: _vm.getIconMask(i)
        }
      })]) : _c('img', {
        staticClass: "function__icon",
        attrs: {
          "src": i.icon_url
        }
      }), _c('div', {
        staticClass: "function__title"
      }, [_vm._v(_vm._s(i.title))])])] : [_c('router-link', {
        attrs: {
          "to": _vm.parseIntentAndRoute(i)
        }
      }, [i.icon_url == undefined || i.icon_url.split('.').pop() == 'svg' ? _c('div', {
        staticClass: "function__icon__wrapper"
      }, [_c('img', {
        staticClass: "function__icon",
        style: {
          maskImage: _vm.getIconMask(i),
          webkitMaskImage: _vm.getIconMask(i)
        }
      })]) : _c('img', {
        staticClass: "function__icon",
        attrs: {
          "src": i.icon_url
        }
      }), _c('div', {
        staticClass: "function__title"
      }, [_vm._v(_vm._s(i.title))])])]], 2);
    }), 0)]) : _vm._e(), section.key === 'menu_list_section' ? _c('div', [_c('div', {
      staticClass: "menu"
    }, _vm._l(section.menu_items, function (i, idx) {
      return _c('span', {
        key: idx
      }, [!i.is_external ? _c('router-link', {
        staticClass: "menu__item",
        attrs: {
          "to": _vm.parseIntentAndRoute(i)
        }
      }, [_c('span', {
        staticClass: "menu__title"
      }, [_vm._v(_vm._s(i.title))]), _c('svg', {
        attrs: {
          "width": "18",
          "height": "19",
          "viewBox": "0 0 18 19",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M13.2773 9.85059C13.2773 9.65723 13.1982 9.48144 13.0576 9.34961L6.44824 3.00391C6.32519 2.88086 6.17578 2.81055 5.99121 2.81055C5.62207 2.81055 5.34082 3.0918 5.34082 3.45215C5.34082 3.62793 5.41113 3.79492 5.52539 3.91797L11.6953 9.8418L5.52539 15.7744C5.41113 15.8975 5.34082 16.0557 5.34082 16.2314C5.34082 16.6006 5.62207 16.8818 5.99121 16.8818C6.17578 16.8818 6.3252 16.8027 6.44824 16.6885L13.0576 10.334C13.1982 10.1934 13.2773 10.0352 13.2773 9.85059Z",
          "fill": "#C4C4C4"
        }
      })])]) : _c('a', {
        staticClass: "menu__item",
        attrs: {
          "href": i.url,
          "target": i.target ? i.target : '_blank'
        }
      }, [_c('span', {
        staticClass: "menu__title"
      }, [_vm._v(_vm._s(i.title))]), _c('svg', {
        attrs: {
          "width": "18",
          "height": "19",
          "viewBox": "0 0 18 19",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M13.2773 9.85059C13.2773 9.65723 13.1982 9.48144 13.0576 9.34961L6.44824 3.00391C6.32519 2.88086 6.17578 2.81055 5.99121 2.81055C5.62207 2.81055 5.34082 3.0918 5.34082 3.45215C5.34082 3.62793 5.41113 3.79492 5.52539 3.91797L11.6953 9.8418L5.52539 15.7744C5.41113 15.8975 5.34082 16.0557 5.34082 16.2314C5.34082 16.6006 5.62207 16.8818 5.99121 16.8818C6.17578 16.8818 6.3252 16.8027 6.44824 16.6885L13.0576 10.334C13.1982 10.1934 13.2773 10.0352 13.2773 9.85059Z",
          "fill": "#C4C4C4"
        }
      })])])], 1);
    }), 0)]) : _vm._e(), section.key === 'member_detail_section' ? _c('div', {
      staticClass: "px-2"
    }, _vm._l(_vm.detail_fields, function (group, idx) {
      return _c('div', {
        key: idx,
        staticClass: "detail"
      }, [_c('div', {
        staticClass: "detail__wrapper"
      }, _vm._l(group, function (field, index2) {
        return _c('div', {
          key: 'field' + index2,
          staticClass: "detail__item",
          class: field.col_span
        }, [_c('div', {
          staticClass: "detail__title"
        }, [_vm._v(_vm._s(field.title))]), _c('div', {
          staticClass: "detail__value"
        }, [_vm._v(" " + _vm._s(_vm.getFieldDisplayValue(field)) + " ")])]);
      }), 0)]);
    }), 0) : _vm._e(), section.key === 'member_point_section' ? _c('div', [_c('div', {
      staticClass: "points-list"
    }, _vm._l(_vm.expiringPoints, function (point, idx) {
      var _vm$moment, _point$point;
      return _c('div', {
        key: idx,
        staticClass: "points-list__item"
      }, [_c('div', {
        staticClass: "points-list__title"
      }, [_vm._v(_vm._s(point.expired_at ? "".concat((_vm$moment = _vm.moment(point.expired_at)) === null || _vm$moment === void 0 ? void 0 : _vm$moment.format('YYYY/MM/DD'), " \u5230\u671F") : '永久有效'))]), _c('div', {
        staticClass: "points-list__point"
      }, [_vm._v(_vm._s((_point$point = point.point) === null || _point$point === void 0 ? void 0 : _point$point.toLocaleString('en-US'))), _c('span', [_vm._v(_vm._s(_vm.displayPointsName))])])]);
    }), 0)]) : _vm._e(), section.key === 'highlight_section' ? _c('div', {
      staticClass: "px-2"
    }, _vm._l(_vm.highlight_fields, function (group, idx) {
      return _c('div', {
        key: idx,
        staticClass: "highlight row"
      }, _vm._l(group, function (field, fdx) {
        return _c('div', {
          key: fdx,
          staticClass: "d-flex flex-column",
          class: field.col_span == 'full' ? 'col-12' : 'col'
        }, [_c('div', {
          staticClass: "highlight__title"
        }, [_vm._v(" " + _vm._s(field.title) + " ")]), _c('div', {
          staticClass: "highlight__value"
        }, [_vm._v(_vm._s(_vm.getFieldDisplayValue(field)))])]);
      }), 0);
    }), 0) : _vm._e(), section.key === 'level_progress_section' ? _c('div', {
      staticClass: "px-2"
    }, [_c('div', {
      staticClass: "level_progress"
    }, [_c('div', {
      staticClass: "level_progress__level"
    }, [_vm._v(_vm._s(_vm.modifiedUser.extra.loyalty_current_level_name))]), _c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('div', [_vm.modifiedUser.extra.loyalty_current_level_start_at || _vm.modifiedUser.extra.loyalty_current_level_end_at ? _c('div', {
      staticClass: "level_progress__period mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.moment(_vm.modifiedUser.extra.loyalty_current_level_start_at).format('YYYY-MM-DD')) + " ~ " + _vm._s(_vm.moment(_vm.modifiedUser.extra.loyalty_current_level_end_at).format('YYYY-MM-DD')))])]) : _vm._e(), _c('div', [_c('span', {
      staticClass: "mr-2"
    }, [_vm._v("累積消費")]), _c('span', {
      staticClass: "level_progress__amount"
    }, [_vm._v("$" + _vm._s(_vm.formatCurrency(_vm.modifiedUser.extra.loyalty_current_level_amount)))])])]), _c('div', {
      staticClass: "d-flex flex-column align-items-end justify-content-end"
    }, [_vm.modifiedUser.extra.loyalty_renewal_level_remaining_amount ? _c('div', [_c('span', {
      staticClass: "level_progress__amount mr-2"
    }, [_vm._v("$" + _vm._s(_vm.formatCurrency(_vm.modifiedUser.extra.loyalty_renewal_level_remaining_amount)))]), _vm._v("續等" + _vm._s(_vm.modifiedUser.extra.loyalty_renewal_level_name) + " ")]) : _vm._e(), _vm.modifiedUser.extra.loyalty_upgrade_level_remaining_amount ? _c('div', [_c('span', {
      staticClass: "level_progress__amount mr-2"
    }, [_vm._v("$" + _vm._s(_vm.formatCurrency(_vm.modifiedUser.extra.loyalty_upgrade_level_remaining_amount)))]), _vm._v("升等" + _vm._s(_vm.modifiedUser.extra.loyalty_upgrade_level_name) + " ")]) : _vm._e()])]), _vm.upgradeRemarkIsEnabled ? _c('div', {
      staticClass: "level_progress__remark"
    }, [_vm._v(" " + _vm._s(_vm.modifiedUser.extra.loyalty_upgrade_level_remark) + " ")]) : _vm._e(), _vm.upgradeProgressBarIsEnabled ? _c('div', {
      staticClass: "level_progress__progress progress my-2"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: {
        width: "".concat(_vm.currentAmount / _vm.upgradeAmount * 100, "%")
      },
      attrs: {
        "role": "progressbar"
      }
    }), _vm.modifiedUser.extra.loyalty_renewal_level_remaining_amount ? _c('div', {
      staticClass: "level_progress__progress__icon",
      style: {
        left: "".concat(_vm.renewalAmount / _vm.upgradeAmount * 100, "%"),
        backgroundColor: _vm.currentAmount < _vm.renewalAmount ? '#e6e6e6' : 'var(--s-primary)',
        transform: _vm.renewalAmount / _vm.upgradeAmount == 0 ? 'translate3D(0, -50%, 0)' : 'translate3D(-10px, -50%, 0)'
      }
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512",
        "fill": "white"
      }
    }, [_vm.currentAmount < _vm.renewalAmount ? _c('path', {
      attrs: {
        "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"
      }
    }) : _c('path', {
      attrs: {
        "d": "M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"
      }
    })])]) : _vm._e(), _vm.modifiedUser.extra.loyalty_upgrade_level_remaining_amount ? _c('div', {
      staticClass: "level_progress__progress__icon",
      style: {
        left: "100%",
        backgroundColor: _vm.currentAmount < _vm.upgradeAmount ? '#e6e6e6' : 'var(--s-primary)',
        transform: 'translateX(-20px) translateY(-50%)'
      }
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512",
        "fill": "white"
      }
    }, [_vm.currentAmount < _vm.upgradeAmount ? _c('path', {
      attrs: {
        "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"
      }
    }) : _c('path', {
      attrs: {
        "d": "M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"
      }
    })])]) : _vm._e()]) : _vm._e(), _vm.upgradeProgressBarIsEnabled ? _c('div', {
      staticClass: "level_progress__text"
    }, [_c('div', {
      staticClass: "level_progress__text__item",
      style: {
        width: "calc(".concat(_vm.renewalAmount / _vm.upgradeAmount * 100, "% - 10px)")
      }
    }), _vm.modifiedUser.extra.loyalty_renewal_level_remaining_amount ? _c('div', {
      staticClass: "level_progress__text__item",
      style: {
        color: _vm.currentAmount >= _vm.renewalAmount ? 'var(--s-primary)' : 'var(--s-gray)'
      }
    }, [_c('div', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v("續等" + _vm._s(_vm.modifiedUser.extra.loyalty_renewal_level_name))]), _c('div', [_vm._v("$" + _vm._s(_vm.formatCurrency(_vm.modifiedUser.extra.loyalty_renewal_level_amount)))])])]) : _vm._e(), _vm.modifiedUser.extra.loyalty_upgrade_level_remaining_amount ? _c('div', {
      staticClass: "level_progress__text__item",
      style: {
        width: "auto",
        color: _vm.currentAmount >= _vm.upgradeAmount ? 'var(--s-primary)' : 'var(--s-gray)',
        flex: '1 1 auto',
        alignItems: 'flex-end'
      }
    }, [_c('div', {
      staticClass: "text-center ml-2"
    }, [_c('div', [_vm._v("升等" + _vm._s(_vm.modifiedUser.extra.loyalty_upgrade_level_name))]), _c('div', [_vm._v("$" + _vm._s(_vm.formatCurrency(_vm.modifiedUser.extra.loyalty_upgrade_level_amount)))])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()]);
  }), _vm.getModuleConfig('intro_section.enable') ? _c('div', {
    staticClass: "mb-3 px-2"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "px-3 py-2"
  }, [_c('h3', {
    staticClass: "info__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("intro_section.form_title")) + " ")]), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("intro_section.form_desc")) + " ")])]), _c('div', {
    staticClass: "info__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('intro_section.content'))
    }
  })])]) : _vm._e(), _vm.getModuleConfig('unbind_button') && _vm.getModuleConfig('unbind_button').enable ? _c('div', {
    staticClass: "p-2 text-center text-small"
  }, [_c('router-link', {
    staticClass: "unbind__button",
    attrs: {
      "to": {
        name: 'LiffMemberCenterUnbind'
      }
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.getModuleConfig("unbind_button").button_text))])])], 1) : _vm._e(), _vm.getModuleConfig('footer_section') && _vm.getModuleConfig('footer_section').enable ? _c('div', {
    staticClass: "p-2 text-center text-small footer__content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('footer_section').content)
    }
  })]) : _vm._e()]], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }